<script>
	import Icon from './General/Icon.svelte';
	import { translate } from '../lib/translate';
	import { img_base, style } from '../lib/store';

	export let id = null;
	export let title = '';
	export let subTitle = '';
	export let image = '';
	export let refId = '';
	export let specs = [];
	export let location = '';
	export let price = 1
</script>

<div class="root {style}">
	<a href="vehicle/used/?id={id}" class="image">
		<img src={img_base + image} alt="">
	</a>
	<div class="content">
		<a href="vehicle/used/?id={id}">
			<h4>{title}</h4>
		</a>
		{#if subTitle}
			<h5>{subTitle}</h5>
		{/if}
		<div class="specs">
			{#each specs as spec}
				<div class="spec">
					{translate(spec)}
				</div>
			{/each}
		</div>
		<div class="location">
			<Icon
				name="MAP_MARKER"
				size="9"
				color="#C8C8C8"
			/>
			<span>{location}</span>
		</div>
		<div class="price">
			{new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(price).replace(',00', '')}
		</div>
	</div>
	<div class="ref-no">
		{#if refId}
			{translate('Ref. no.')}<span>{refId}</span>
		{/if}
	</div>
</div>

<style type="text/scss" lang="scss">
	.root {
		box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
		display: flex;
		flex-direction: column;
	}

	.image {
		width: 100%;
		height: 265px;
		background-color: #EEE;
		overflow: hidden;
		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}

	.content {
		padding: 20px 25px 17px;
		flex-grow: 1;
		display: flex;
		flex-direction: column;

		@media (max-width: 599px) {
			padding: 20px 15px 17px;
		}

		h4 {
			font-size: 22px;
			font-weight: 600;
			line-height: 23px;
			margin-bottom: 8px;
			color: var(--c-primary);
		}
		h5 {
			font-size: 16px;
			font-weight: 400;
			line-height: 25px;
			color: black;
		}
	}

	.specs {
		margin: 17px 0;
		font-size: 12px;
		line-height: 18px;
		.spec {
			display: inline-block;
			&:not(:last-child) {
				&::after {
					content: "|";
					margin: 0 5px;
				}
			}
		}
	}

	.location {
		display: flex;
		font-size: 12px;
		line-height: 18px;
		align-items: center;
		span {
			margin-left: 8.5px;
			color: #C8C8C8;
		}
	}

	.price {
		display: flex;
		align-items: flex-end;
		flex-grow: 1;
		color: var(--c-sky-blue);
		line-height: 55px;
		font-weight: 700;
		font-size: 36px;
		margin-top: 6px;
	}

	.ref-no {
		height: 43px;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #F2F2F2;
		color: #000000;
		span {
			font-weight: 600;
			margin-left: 5px;
		}
	}

	// Style overwrites
	.root.WBS{
		a, h4{
			text-decoration: none;
			color: black;
			font-weight: 600;
		}
		h5, .spec{
			color: #666667;
		}
	}
</style>
